import * as React from 'react'
import { DownloadsProps } from './types'
import { Styled } from './styled'
import { renderRichtext } from '../../lib/utils/renderRichtext'
import { Downloads as DownloadsComponent } from '../../components/UI/Downloads'
import { sbEditable } from '@storyblok/storyblok-editable'

export const Downloads = ({ blok }: DownloadsProps) => {
  return (
    <Styled.Wrapper id={blok.anchorLinkId && blok.anchorLinkId} {...sbEditable(blok)}>
      {blok.headline && (
        <Styled.Headline as={blok.headlineSyntax ? blok.headlineSyntax : 'h2'}>{blok.headline}</Styled.Headline>
      )}
      {blok.description && (
        <Styled.Description className="prose">{renderRichtext(blok.description)}</Styled.Description>
      )}
      <DownloadsComponent downloads={blok.downloadsItems} />
    </Styled.Wrapper>
  )
}
